import React, { FC } from "react";
import { MatterRelationEditor } from "../matter-relation-editor";
import { WorkspaceList } from "../workspace-list";
import { Exclusion } from "../../../data-types";

export type MatterExclusionsEditorProps = {
  loading: boolean;
  exclusions: Exclusion[];
  onAddNew: () => void;
  onSave: (exclusion: Exclusion, text: string) => Promise<void>;
  onDelete: (exclusion: Exclusion) => Promise<void>;
  onReorder: (activeId: number, overId: number) => void;
};

export const MatterExclusionsEditor: FC<MatterExclusionsEditorProps> = ({
  loading,
  exclusions,
  onAddNew,
  onSave,
  onDelete,
  onReorder,
}) => {
  return (
    <MatterRelationEditor
      workspaceContent={
        <WorkspaceList
          workspaceItemType="exclusion"
          itemKeyProperty="id"
          itemTextProperty="text"
          loading={loading}
          items={exclusions}
          deleteItem={(item) => onDelete(item)}
          saveItem={(item, text) => onSave(item, text)}
          onReorder={onReorder}
        />
      }
      addNew={onAddNew}
      showAddNew={true}
    />
  );
};
